<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_i">When the Sleeper Wakes</a></h1><a id="page_i">
<p class="author">H. G. Wells</p>
<div class="img_container_1">
<img alt="Image" src="images/logo.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?a273b000